import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import Snackbar from "@mui/material/Snackbar";
import { HoverWindow } from "commonComponents/HoleUI/CarsOnCourseStyled";
import CarNotAvailableModal from "../CarNotAvailableModal";
import SignalIcon from "assets/svgIcons/SignalIcon";
import { reasonForReportString, carType, memberCarTrackingLevel, getFeatureSetOption, getFeaturesList, controlType, isUserAdmin, isUserSupport, deviceType } from "constant";

import SendMsgToCars from "../popups/SendMsgToCars";
import CarDetailsOnCarIcon from "../popups/CarDetailsOnCarIcon";
import LoadingBackdrop from "../popups/LoadingBackdrop";
import { Modal } from "@mui/material";
import { PopUpContainer } from "assets/css/globle";
import { Box } from "@mui/system";
import { showSpecifiCarHistory } from "../functions/showSpecifiCarHistory";
import {
    UPDATED_CAR_DATA_STATE,
    MAP_GLOBAL_STATES,
    SLIDER_STATE,
    COMMON_COMPONENTS_STATES,
    SITEID_GLOBAL_STATE,
    MESSAGE_FLEET_GLOBAL_STATES
} from "globalStore/globalStore";
import { filterCars } from "../carFilter";
import { showSpecifiCarTrackLocation } from "../functions/showSpecifiCarTrackLocation";
import { getMapBoundsForFindCars } from "../functions/getMapBoundsForFindCars";
import { getMapBoundsForAllCars } from "../functions/getMapBoundsForAllCars";
import { isValidLocation } from "_helperFunctions/isValidLocation";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { HistoryIconPopup } from "../HistoryIconPopup";
import { getPaceString } from "../functions/getPaceString";
import { uuid } from "_helperFunctions/uuid";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import { shouldShowEngineHours } from "_helperFunctions/shouldShowEngineHours";

export const CarInfo = ({
    mapReady,
    clickState,
    setClickState,
    snackbarState,
    carSnackbarInfo,
    CTDModal,
    setCTDModal,
    mapData,
    mapsData,
    carData,
    setCarData,
    setSite,
    setSnackbarState,
    clickToDrivefeature,
    zoomToShowAll,
    setZoomToShowAll,
    isActiveCarList,
    setActiveCarList,
    CarList,
    displayCars
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isSiteUsingYards, convertMileToKM } = useCarSettingsData();

    const { showTaggedCarArrayClickToDrive, historyNoDataPopup, selectedHistoryOption, memberCarTracking } = useHookstate(MAP_GLOBAL_STATES);

    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const {
        messageFindCar,
        paceFindCar,
        taggedCarsSaverGlobalState,
        mapCarsSelectAll,
        marshalCarsGlobalState,
        specialCarsGlobalState,
        memberCarsGlobalState,
        beverageCarsGlobalState,
        fleetCarsGlobalState,
        notInUseCarsGlobalState,
        carsNotCommunicatingGlobalState,
        outsidePerimeterGlobalState,
        specificCarTrackHistory,
        showTaggedCar,
        historyOptions,
        carHistoryList,
        loadingOnProcess,
        specificHistoryClicked,
        getCheckedCars,
        enableClickToDriveFeature,
        carsInEnergySaverGlobalState
    } = useHookstate(MAP_GLOBAL_STATES);
    const { sliderState } = useHookstate(SLIDER_STATE);
    const { findCars } = useHookstate(COMMON_COMPONENTS_STATES);

    const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

    const {
        getCarPathActionZone,
        siteSettingsData,
        specificCarHistoryData,
        getCarTrackData,
        getUserRole,
        getHoleAreasState,
        getSiteAreasState,
        clickToDriveApiStatus,
        carProductData
    } = useSelector((state) => state.commonReducers) || [];

    const taggedCarsSaverGlobalStateValue = taggedCarsSaverGlobalState.get();
    const mapCarsSelectAllValue = mapCarsSelectAll.get();
    const marshalCarsGlobalStateValue = marshalCarsGlobalState.get();
    const specialCarsGlobalStateValue = specialCarsGlobalState.get();
    const memberCarsGlobalStateValue = memberCarsGlobalState.get();
    const beverageCarsGlobalStateValue = beverageCarsGlobalState.get();
    const fleetCarsGlobalStateValue = fleetCarsGlobalState.get();
    const notInUseCarsGlobalStateValue = notInUseCarsGlobalState.get();
    const carsNotCommunicatingGlobalStateValue = carsNotCommunicatingGlobalState.get();
    const carsInEnergySaverGlobalStateValue = carsInEnergySaverGlobalState.get();
    const outsidePerimeterGlobalStateValue = outsidePerimeterGlobalState.get();
    const updatedCarDataValue = updatedCarData.get();
    const specificCarTrackHistoryValue = specificCarTrackHistory.get();
    const sliderStateValue = sliderState.get();
    const findCarsValue = findCars.get();
    const messageFindCarValue = messageFindCar.get();
    const paceFindCarValue = paceFindCar.get();

    var polyLinesData = [];

    const { vertical, horizontal, openSnackbar } = snackbarState;

    const [hoverStateHistory, setHoverStateHistory] = useState({});
    const [hoverState, setHoverState] = useState({});
    const [polyLineState, setPolyLineState] = useState([]);
    const [actionZonePoints, setActionZonePoints] = useState([]);
    const [allCarData, setAllCarData] = useState([]);
    const [carLocationActivated, setCarLocationActivated] = useState(false);
    const [carTrackPolyLineState, setCarTrackPolyLineState] = useState([]);
    const [carHistoryMarkers, setCarHistoryMarkers] = useState([]);
    const [notAvailableCars, setNotAvailableCars] = useState([]);
    const [openPopupNotAvailableCars, setOpenPopupNotAvailableCars] = useState(false);
    const [CTDListenerAdded, setCTDListenerAdded] = useState(false);
    const [clickStateProductData, setClickStateProductData] = useState(null);
    const [hoverStateProductData, setHoverStateProductData] = useState(null);

    const actionRef = useRef();
    const polyRef = useRef();

    if (mapData && mapsData) {
        var HistoryTypeEnum = {
            History: {
                value: 0,
                name: "History",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
            GPRS: {
                value: 1,
                name: "GPRS Xmit State",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
            GPS: {
                value: 2,
                name: "GPS Quality",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
            WiFi: {
                value: 3,
                name: "Wi-Fi Signal",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
        };
    }

    useEffect(() => {
        if (siteSettingsData?.MemberCarTrackingLevel !== undefined && siteSettingsData?.MemberCarTrackingLevel !== null) {
            const backendEnumValue = siteSettingsData.MemberCarTrackingLevel;
            const selectedStringValue = Object.keys(memberCarTrackingLevel)
                .find(key => memberCarTrackingLevel[key] === backendEnumValue);

            if (selectedStringValue) {
                memberCarTracking.set(selectedStringValue);
            }
        }
    }, [siteSettingsData]);

    // Fetch product data when clickState changes
    useEffect(() => {
        if (clickState?.data?.GpsiCarId) {
            dispatch(COMMON_SERVICES.getProductData(clickState.data.GpsiCarId));
        }
    }, [clickState?.data?.GpsiCarId]);

    // Sync carProductData from Redux when it matches the clickState car
    useEffect(() => {
        if (carProductData && carProductData.GpsiCarId === clickState?.data?.GpsiCarId) {
            setClickStateProductData(carProductData);
        }
    }, [carProductData, clickState?.data?.GpsiCarId]);

    // Fetch product data when hoverState changes
    useEffect(() => {
        if (hoverState?.data?.GpsiCarId) {
            dispatch(COMMON_SERVICES.getProductData(hoverState.data.GpsiCarId));
        }
    }, [hoverState?.data?.GpsiCarId]);

    // Sync carProductData from Redux when it matches the hoverState car
    useEffect(() => {
        if (carProductData && carProductData.GpsiCarId === hoverState?.data?.GpsiCarId) {
            setHoverStateProductData(carProductData);
        }
    }, [carProductData, hoverState?.data?.GpsiCarId]);

    useEffect(() => {
        showSpecifiCarHistory(
            mapData,
            mapsData,
            memberCarTracking,
            polyLineState,
            setPolyLineState,
            actionZonePoints,
            setActionZonePoints,
            polyRef,
            actionRef,
            specificCarHistoryData,
            historyOptions.get(),
            polyLinesData,
            carHistoryList,
            getUserRole,
            setHoverStateHistory,
            loadingOnProcess,
            specificHistoryClicked,
            getCarPathActionZone,
            getSiteAreasState,
            getHoleAreasState,
            getFeatureSetOption,
            siteSettingsData,
            getFeaturesList
        );
    }, [specificCarHistoryData, historyOptions.get(), memberCarTracking.get()]);

    useEffect(() => {
        let localCarData = !Array.isArray(updatedCarDataValue) && typeof updatedCarDataValue === "string" && JSON.parse(updatedCarDataValue);

        if (localCarData) {
            if (updatedCarDataValue && Array.isArray(localCarData) && localCarData.length !== 0) {
                if (!carLocationActivated) {
                    localStorage.setItem("mapCarsSelectAll", "true");
                    setCarData([...localCarData]);
                    setAllCarData([...localCarData]);
                }
            } else {
                setCarData([]);
                setAllCarData([]);
            }
        }
    }, [updatedCarDataValue]);

    useEffect(() => {
        if (JSON.stringify(carData) !== JSON.stringify(filterCars(
            allCarData,
            mapCarsSelectAllValue,
            fleetCarsGlobalStateValue,
            marshalCarsGlobalStateValue,
            specialCarsGlobalStateValue,
            memberCarsGlobalStateValue,
            beverageCarsGlobalStateValue,
            notInUseCarsGlobalStateValue,
            carsNotCommunicatingGlobalStateValue,
            outsidePerimeterGlobalStateValue,
            taggedCarsSaverGlobalStateValue,
            mapsData,
            siteSettingsData,
            getUserRole,
            getHoleAreasState,
            getSiteAreasState,
            getCarPathActionZone,
            carsInEnergySaverGlobalStateValue
        )) && !carLocationActivated) {
            setCarData([
                ...filterCars(
                    allCarData,
                    mapCarsSelectAllValue,
                    fleetCarsGlobalStateValue,
                    marshalCarsGlobalStateValue,
                    specialCarsGlobalStateValue,
                    memberCarsGlobalStateValue,
                    beverageCarsGlobalStateValue,
                    notInUseCarsGlobalStateValue,
                    carsNotCommunicatingGlobalStateValue,
                    outsidePerimeterGlobalStateValue,
                    taggedCarsSaverGlobalStateValue,
                    mapsData,
                    siteSettingsData,
                    getUserRole,
                    getHoleAreasState,
                    getSiteAreasState,
                    getCarPathActionZone,
                    carsInEnergySaverGlobalStateValue
                ),
            ]);
        }
    }, [
        mapCarsSelectAllValue,
        fleetCarsGlobalStateValue,
        marshalCarsGlobalStateValue,
        specialCarsGlobalStateValue,
        memberCarsGlobalStateValue,
        beverageCarsGlobalStateValue,
        notInUseCarsGlobalStateValue,
        carsNotCommunicatingGlobalStateValue,
        outsidePerimeterGlobalStateValue,
        carData,
        carLocationActivated,
        taggedCarsSaverGlobalStateValue,
        carsInEnergySaverGlobalStateValue
    ]);

    const pointInPolygon = (point, polygon, longitudePropertyName, latitudePropertyName) => {
        var y = point[0], x = point[1];
        var inside = false;
        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i][longitudePropertyName], yi = polygon[i][latitudePropertyName];
            var xj = polygon[j][longitudePropertyName], yj = polygon[j][latitudePropertyName];

            var intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    }

    const isCarInsideGeofence = (lat, lng) => {
        let actionZones = getCarPathActionZone?.filter((az) => {
            return az.IsGeofence;
        })
        if (!actionZones || Object.keys(actionZones).length <= 0) {
            return false;
        }
        var point = [lat, lng];
        var inside = pointInPolygon(point, actionZones[0].AzVertexes, 'Longitude', 'Latitude');
        return inside;
    }

    function isCarOnCourse(lat, lng) {
        let point = [lat, lng];
        for (let i = 0; i < getSiteAreasState?.length; i++) {
            if (pointInPolygon(point, getSiteAreasState[i]?.Polygon, "Lon", "Lat")) {
                return true;
            }
        }

        for (let i = 0; i < getHoleAreasState?.length; i++) {
            if (pointInPolygon(point, getHoleAreasState[i]?.Polygon, "Lon", "Lat"))
                return true;
        }
        return false;
    }
    function hasValidLocation(lat, lng) {
        if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.Always) {
            return true;
        }
        else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.Never) {
            return false;
        }
        else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.InsideGeoFence) {
            return isCarInsideGeofence(lat, lng);
        }
        else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.OnCourseOrPlayingGolf) {
            return isCarOnCourse(lat, lng);
        }
    }
    useEffect(() => {
        if (getCarTrackData?.length > 0 && mapsData) {
            let track = [];
            if (specificCarTrackHistoryValue) {
                track = getCarTrackData.filter((it) => {
                    const isInTimeRange = moment.utc(it.LastLocationUpdateInUtc) >= moment.utc(sliderStateValue[0]) &&
                        moment.utc(it.LastLocationUpdateInUtc) <= moment.utc(sliderStateValue[1]);

                    if (!isInTimeRange) return false;

                    const isAdminOrSupport = isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role);
                    const isNotMemberCar = it.CarType !== carType.member;

                    if (isNotMemberCar || isAdminOrSupport) return true;

                    const memberCarFeature = !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);
                    const isLocationValid = hasValidLocation(it.Latitude, it.Longitude);
                    return memberCarFeature && isLocationValid;
                });
            }
            showSpecifiCarTrackLocation(
                track,
                carTrackPolyLineState,
                setCarTrackPolyLineState,
                carHistoryMarkers,
                setCarHistoryMarkers,
                mapData,
                mapsData,
                setHoverState,
                clickState,
                setClickState
            );

            if (getCarTrackData.length > 0 && specificCarTrackHistoryValue) {
                setCarLocationActivated(true);
                setCarData(allCarData.filter((item) => item.Car.CarNumber === showTaggedCar.get()));
            } else {
                setCarLocationActivated(false);
            }
        } else if (getCarTrackData?.length === 0 && specificCarTrackHistoryValue) {
            showSpecifiCarTrackLocation(
                [],
                carTrackPolyLineState,
                setCarTrackPolyLineState,
                carHistoryMarkers,
                setCarHistoryMarkers,
                mapData,
                mapsData,
                setHoverState,
                clickState,
                setClickState
            );
            setCarLocationActivated(false);
        }
    }, [getCarTrackData, specificCarTrackHistoryValue, sliderStateValue[0], sliderStateValue[1]]);

    useEffect(() => {
        if (!specificCarTrackHistoryValue) {
            setClickState({});
        }
    }, [specificCarTrackHistoryValue]);

    useEffect(() => {
        if (mapReady && mapData && mapsData &&
            Object.keys(taggedCarsSaverGlobalStateValue).length > 0 ||
            Object.keys(findCarsValue).length > 0 ||
            Object.keys(paceFindCarValue).length > 0 &&
            Object.keys(updatedCarDataValue).length > 0) {
            mapBound();
        }
    }, [mapReady, taggedCarsSaverGlobalStateValue, findCarsValue, messageFindCarValue, paceFindCarValue, updatedCarDataValue]);

    useEffect(() => {
        if (zoomToShowAll) {
            findCars.set(false);
            if (mapData && mapsData && mapReady) {
                mapBound();
            }
        }
    }, [mapReady, zoomToShowAll]);

    useEffect(() => {
        if (clickToDriveApiStatus === "success") {
            setTimeout(() => {
                setSnackbarState({ ...snackbarState, openSnackbar: false });
            }, 2000);

            setTimeout(() => {
                dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
            }, 3000);
        }
    }, [clickToDriveApiStatus]);

    useEffect(() => {
        return () => {
            isLoading.set(false);
            getCheckedCars.set([
                { carName: "fleetCars", carType: carType.normal, isChecked: true },
                { carName: "marshalCars", carType: carType.marshal, isChecked: false },
                { carName: "beverageCars", carType: carType.bevcart, isChecked: false },
                { carName: "specialNeedsCars", carType: carType.handicap, isChecked: true },
                { carName: "memberCars", carType: carType.member, isChecked: true },
                { carName: "notCommunicatingCars", carType: carType.notCommunicating, isChecked: false },
                { carName: "notInUseCars", carType: carType.notInUse, isChecked: false },
                { carName: "outsidePerimeterCars", carType: carType.outOfService, isChecked: false },
                { carName: "cometTrailsOnHover", isChecked: false },
                { carName: "energySavingCars", isChecked: false },
            ]);
        };
    }, []);
    useEffect(() => {
        dispatch(COMMON_SERVICES.getSiteAreasServices(siteId.get()));
        dispatch(COMMON_SERVICES.getHoleAreasServices(siteId.get()));
    }, [siteId.get(), siteSettingsData]);
    useEffect(() => {
        if (mapsData && mapData) {
            if (enableClickToDriveFeature.get() && !CTDListenerAdded) {
                mapsData.event.addListener(mapData, "rightclick", function (event) {
                    clickToDrivefeature(event);
                });

                setCTDListenerAdded(true);

                mapData.getDiv().className = "azEditCursorAlias";
            } else if (!enableClickToDriveFeature.get()) {
                mapData.getDiv().className = "azEditCursorDefault";
            }
        }
    }, [enableClickToDriveFeature.get(), mapData, mapsData, CTDListenerAdded]);

    useEffect(() => {
        if (mapReady && mapData && mapsData &&
            Object.keys(findCarsValue).length > 0 && Object.keys(updatedCarDataValue).length > 0) {
            setZoomToShowAll(false);

            if (mapData && mapsData) {
                mapBound();
            }
        }
    }, [mapReady, findCarsValue, updatedCarDataValue]);

    useEffect(() => {
        if (HistoryTypeEnum) {
            selectedHistoryOption.set(
                Object.values(HistoryTypeEnum).find(
                    (it) => it.value === historyOptions.get()
                )
            );
        }
    }, [historyOptions.get()]);

    const mapBound = () => {
        let taggedCars = JSON.parse(JSON.stringify(taggedCarsSaverGlobalStateValue));

        if (((findCarsValue && taggedCars.length > 0) || messageFindCarValue || paceFindCarValue) && !zoomToShowAll) {
            let localAllData = allCarData;
            let localCarData = carData;
            let updatedCarDataValueData = !Array.isArray(updatedCarDataValue) && typeof updatedCarDataValue === "string" && JSON.parse(updatedCarDataValue);

            if (updatedCarDataValue && Array.isArray(updatedCarDataValueData) && updatedCarDataValueData.length !== 0) {
                localAllData = allCarData.length == 0 ? updatedCarDataValueData : allCarData;
                localCarData = carData.length == 0 ? updatedCarDataValueData : carData;
            }

            const bounds = getMapBoundsForFindCars(
                mapData,
                mapsData,
                taggedCarsSaverGlobalStateValue,
                localCarData,
                localAllData,
                isValidLocation,
                setNotAvailableCars,
                getMapBoundsForAllCars,
                setOpenPopupNotAvailableCars,
                setZoomToShowAll
            );
            mapData.fitBounds(bounds);
            findCars.set(false);
        }

        if (!findCarsValue && zoomToShowAll) {
            if (carData.length > 0) {
                const bounds = getMapBoundsForAllCars(
                    mapData,
                    mapsData,
                    carData,
                    isValidLocation,
                    setZoomToShowAll
                );
                mapData.fitBounds(bounds);
            } else {
                setZoomToShowAll(false);
                setSite(true);
            }
        }
    }

    const CTDStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "100%",
        bgcolor: "#fff",
        borderRadius: "5px",
        overflow: "hidden",
    }

    const historyModalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "calc(100% -  40px)",
        bgcolor: "#fff",
        borderRadius: "5px",
        overflow: "hidden",
    }

    const getOdometerDisplay = (carProductDataParam) => {
        if (!carProductDataParam || !carData) return "";
        const car = carData?.[0]?.Car;
        const odometerBase = car?.GPSOdometerBase ?? 0;
        let odometer;

        if (carProductDataParam?.CarHistoryOdometer !== null && carProductDataParam?.CarHistoryOdometer !== undefined && carProductDataParam?.CarHistoryOdometer !== 0
        ) {
            odometer = carProductDataParam.CarHistoryOdometer;
        } else if (carProductDataParam?.DevType === deviceType.FT2) {
            odometer = carProductDataParam.Odometer;
        } else if (!car?.CanCarCommunicate) {
            odometer = carProductDataParam.GPSOdometer;
        } else {
            odometer = carProductDataParam.Odometer ?? carProductDataParam.GPSOdometer ?? 0;
        }

        if (car?.CarControlType === controlType.None) {
            odometer += odometerBase;
        }

        const isMiles = isSiteUsingYards();
        if (isMiles) {
            const miles = Math.round(odometer);
            return `${miles} ${t(miles === 1 ? "Mile" : "Miles")}`;
        } else {
            const km = Math.round(convertMileToKM(odometer));
            return `${km} ${t(km === 1 ? "km" : "kms")}`;
        }
    };

    const getHrMeterDisplay = (carProductDataParam) => {
        if (!carProductDataParam || !carData) return "";
        const car = carData?.[0]?.Car;

        const hourMeterVal = car?.DevType === deviceType.FT2
            ? carProductDataParam.CarHistoryHourMeter
            : carProductDataParam.HourMeter;

        const hrMeter = Math.round(hourMeterVal + (car?.VirtualHourmeterBase ?? 0));
        return `${hrMeter} ${t(hrMeter === 1 ? "hour" : "hours")}`;
    };

    const getCarMakeModelWithYear = (carInformation) => {
        if (!carInformation?.CarMake && !carInformation?.CarModel && !carInformation.NonCommunicativeVehicle) return null;

        const fullSerial = carInformation?.FullSerialNumber;
        let year = carInformation?.NonCommunicativeVehicle?.CarYear || "";
        const carMake = carInformation?.CarMake || carInformation?.NonCommunicativeVehicle?.CarMake || "";
        const carModel = carInformation?.CarModel || carInformation?.NonCommunicativeVehicle?.CarModel || "";

        if (fullSerial && fullSerial.length >= 2) {
            const startIndex = fullSerial.length === 12 ? 1 : 2;
            const endIndex = startIndex + 2;
            // prepend 20 to populate year in "YYYY" format
            year = "20" + fullSerial.substring(startIndex, endIndex);
        }

        return `${year} ${carMake} ${carModel}`.trim();
    };

    return (
        <>
            {!isActiveCarList &&
                <CarList
                    setActiveCarList={setActiveCarList}
                    isActiveCarList={isActiveCarList}
                    displayCars={() => displayCars(carData, getCheckedCars.get())}
                />
            }

            {hoverStateHistory?.state ? (
                <HoverWindow
                    style={{
                        position: "fixed",
                        top: `${hoverStateHistory.top}`,
                        left: `${hoverStateHistory.left}`,
                    }}
                >
                    <div className="wrapper">
                        <h3>Car: {hoverStateHistory.car}</h3>
                        <p>{hoverStateHistory.TimeStamp}</p>
                    </div>
                </HoverWindow>
            ) : (
                <></>
            )}

            {/* ================================================== TOOLTIP FOR CAR LOCATIONS =========================================== */}
            {hoverState?.state && !clickState.state ? (
                <HoverWindow style={{ position: "fixed", top: `${hoverState.top}`, left: `${hoverState.left}` }}>
                    <div className="wrapper">
                        <div className="carSignalIcon">
                            <h3>Car: {hoverState.data.CarNumber}</h3>
                            <SignalIcon width="16px" height="12.5px" color="gray" />
                        </div>
                        <div style={{ fontSize: 13, fontWeight: "bold" }}>
                            {getCarMakeModelWithYear(hoverState.data)}
                        </div>
                        <p>
                            {moment
                                .utc(hoverState.data.LastLocationUpdateInUtc)
                                .utcOffset(
                                    siteSettingsData && -siteSettingsData?.TimeZoneOffset
                                )
                                .format("DD-MMM-YYYY, h:mm a")}
                        </p>

                        {hoverState.data.PlayerName1 !== null ? (
                            <p>{hoverState.data.PlayerName1}</p>
                        ) : (
                            <></>
                        )}
                        {hoverState.data.PlayerName2 !== null ? (
                            <p>{hoverState.data.PlayerName2}</p>
                        ) : (
                            <></>
                        )}

                        <p>
                            <span style={{ fontSize: 16 }}>
                                {hoverState.data.HoleLocation === 0
                                    ? "Not playing"
                                    : hoverState.data.HoleLocation === 1
                                        ? `Hole ${hoverState.data.Hole} Between Holes `
                                        : hoverState.data.HoleLocation === 2
                                            ? `Hole ${hoverState.data.Hole} Tee`
                                            : hoverState.data.HoleLocation === 3
                                                ? `Hole ${hoverState.data.Hole} Fairway`
                                                : hoverState.data.HoleLocation === 4
                                                    ? `Hole ${hoverState.data.Hole} Green`
                                                    : ""}
                            </span>
                            <br />
                        </p>
                        <p style={{ fontSize: 16 }}>
                            {getPaceString(hoverState.data)}
                        </p>
                        <p>
                            {t("Report_Reason")}:
                            {reasonForReportString(hoverState.data.LocationReasonForReport)}
                        </p>
                        <p>
                            {t("GPRS_Signal")}:{hoverState.data.LocationGprsSignalStrength}{" "}
                        </p>
                        <p>
                            {t("Sequence")} #:{hoverState.data.LocationSequenceNumber}{" "}
                        </p>
                        {hoverStateProductData &&
                            <>
                                <p style={{ fontWeight: "bold" }}>
                                    {t("Odometer")}: {getOdometerDisplay(hoverStateProductData)}
                                </p>

                                {shouldShowEngineHours(hoverState.data, hoverStateProductData) && <p style={{ fontWeight: "bold" }}>
                                    {t("Engine")}: {getHrMeterDisplay(hoverStateProductData)}
                                </p>}
                            </>
                        }
                    </div>
                </HoverWindow>
            ) : (
                <></>
            )}

            {clickState.data && (
                <HistoryIconPopup
                    key={uuid()}
                    clickState={clickState}
                    getPaceString={getPaceString}
                    setClickState={setClickState}
                    carProductData={clickStateProductData}
                    carData={carData}
                />
            )}

            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={openSnackbar}
                message={
                    <span>
                        {`Position sent for ${showTaggedCarArrayClickToDrive.get().length
                            } car(s)`}
                        <br />
                        {carSnackbarInfo.lat}
                        <br />
                        {carSnackbarInfo.lng}
                    </span>
                }
                key={vertical + horizontal}
            />
            <CarNotAvailableModal
                notAvailableCars={notAvailableCars}
                openPopupNotAvailableCars={openPopupNotAvailableCars}
                setOpenPopupNotAvailableCars={setOpenPopupNotAvailableCars}
            />
            <SendMsgToCars />

            <CarDetailsOnCarIcon />
            <LoadingBackdrop />
            <Modal
                open={CTDModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={CTDStyle}>
                    <PopUpContainer>
                        <h2>{t("No_target_car(s)")}</h2>
                        <p>{t("Target_car_number(s)_must_be_specified")}</p>
                        <div className="action-btn">
                            <button className="primary" onClick={() => setCTDModal(false)}>
                                {t("Ok")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>

            <Modal
                open={historyNoDataPopup.get()}
                onClose={() => historyNoDataPopup.set(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={historyModalStyle}>
                    <PopUpContainer>
                        <h2>Visage</h2>
                        <p> {t("No_data_was_available_to_display_on_the_map")}</p>
                        <div className="action-btn">
                            <button
                                onClick={() => {
                                    historyNoDataPopup.set(false);
                                }}
                            >
                                {t("Ok")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>
        </>
    );
};